'use client'

import { LineEye } from '@qr-front/icons/line-eye'
import { LineEyeOff } from '@qr-front/icons/line-eye-off'
import { LineLock } from '@qr-front/icons/line-lock'
import { InputField } from '@qr-front/ui/components/InputField'
import { cn } from '@qr-front/ui/utils'
import * as React from 'react'
import { useState } from 'react'

export interface InputFieldPasswordProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	error?: string
	label?: string
}

const InputFieldPassword = React.forwardRef<
	HTMLInputElement,
	InputFieldPasswordProps
>(({ error, value, ...props }, ref) => {
	const [showPassword, setShowPassword] = useState(false)
	const RightIcon = showPassword ? LineEye : LineEyeOff

	return (
		<InputField
			leftIcon={LineLock}
			rightIcon={RightIcon}
			rightOnClick={() => setShowPassword(!showPassword)}
			error={error}
			type={showPassword ? 'text' : 'password'}
			inputClassName={cn(value && !showPassword && 'tracking-widest')}
			value={value}
			ref={ref}
			{...props}
		/>
	)
})
InputFieldPassword.displayName = 'InputFieldPassword'

export { InputFieldPassword }
